import { useMemo } from "react";
import { useHistory } from "react-router-dom";

export const useHistoryState = <T>(): T | undefined => {
	const history = useHistory<T>();

	return useMemo(() => {
		return history.location.state;
	}, [history.location.state]);
};